<script>

    import Panel from './Panel'

    export default {
        name: 'invoices-form',

        /**
         * The components the page can use.
         */
        components: {
            Panel
        },

        /**
         * List passable properties
         *
         * @type {Array}
         */
        props: [
            'invoice',
            'serviceTypes',
        ],

        /**
         * The data that can be used by the page.
         *
         * @returns {Object} The view-model data.
         */
        data() {
            return {
                record : this.invoice
            };
        },

        /**
         * Prepare the component.
         */
        created() {
        },

        /**
         * Prepare the component.
         */
        mounted() {
        },

        /**
         * Clean after the component is destroyed.
         */
        destroyed(){
        },

         /**
         * Components computed values
         * For example: value : function(){},
         *
         * @type {Object}
         */
        computed: {
            /**
             * @return {Collection} Collect items that are selected
             */
            selected : function() {
                return _.filter(this.record.details, (item) => item.is_selected)
            },

            balance : {
                get() {
                    return this.invoice.balance || this.total()
                },

                set(value) {
                    this.invoice.balance = value
                }
            },
        },

        /**
         * Components methods
         * Each element is a function()
         *
         * @type {Object}
         */
        methods:{
            /**
             * Add new Detail to upper Invoice
             *
             * @param {void} item
             */
            addNewDetail: function(serviceType){
                this.invoice.details.push(this.newDetail(serviceType));
            },

            /**
             * Create the new Detail
             *
             * @return {Object}
             */
            newDetail: function(serviceType){
                let service = _.first(serviceType.services)

                let newDetail = {
                    service_type_id: serviceType.id,
                    service: service,
                    service_id:_.get(service, 'id'),
                    modifier_id:_.chain(service).get('modifiers').first().get('pivot.modifier_id').value(),
                    units:null,
                    price_id:null,
                    // Cost must be undefined so that we can evaluate it
                    // cost:null,
                }

                return newDetail
            },

            /**
             * Remove the details
             *
             * @param  {array} items
             * @return {void}
             */
            removeDetails: function(items){
                let self = this
                _.each(items, function(item){
                    self.removeDetail(item)
                })
            },

            /**
             * Remove the detail from invoice.details array
             *
             * @param  {Object} detail
             * @return {void}
             */
            removeDetail: function(detail){
                // Lock the visibility
                detail.is_locked = true,

                this.invoice.details.splice(_.findIndex(this.invoice.details, detail), 1);

                if (!detail.id) {
                } else {
                    // send the request
                    axios.delete('/api/invoiceDetails/'+ detail.id ).then((response)=>{
                        console.log(response, response.data)
                        // this.invoice.details.splice(_.findIndex(this.invoice.details, detail), 1);
                    }).catch((response)=>{
                        console.log(response, response.data)
                    }).finally(()=>{
                        console.log('finally')
                    })
                }
            },

            /**
             * Calculate the running total
             *
             * @return {float}
             */
            total: function(){

            }
        },
    }
</script>

<template>
    <div v-if="record">
        <panel v-for="(serviceType, index) in serviceTypes"
            v-on:add-new-detail="addNewDetail"
            :key="serviceType.id"
            :serviceType="serviceType"
            :invoice="record">
        </panel>
        <div class="form-group" v-if="selected.length">
            <button type="button" class="btn btn-danger" @click="removeDetails(selected)">
                <i class="mdi md-delete"></i> Delete Selected
            </button>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// resources/js/components/invoice/Form.vue